'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '@/lib/utils';

export const NAVIGATION = [
  { name: 'Search Homes', href: '/homes' },
  { name: 'Markets', href: '/markets' },
  { name: 'Pricing', href: '/pricing' },
  { name: 'Learn', href: '/learn' },
] as const;

export default function NavLinks({
  className,
  onNavigate,
}: {
  className?: string;
  onNavigate?: () => void;
}) {
  const pathname = usePathname();

  return (
    <div className={className}>
      {NAVIGATION.map((item) => {
        const active = pathname === item.href || pathname?.startsWith(item.href + '/');
        return (
          <Link
            key={item.name}
            href={item.href}
            onClick={onNavigate}
            className={cn(
              'rounded-lg px-4 py-2 text-sm font-medium transition-colors',
              active
                ? 'bg-emerald-500/10 text-emerald-700'
                : 'text-ink-muted hover:bg-glass hover:text-ink'
            )}
          >
            {item.name}
          </Link>
        );
      })}
    </div>
  );
}
